export default __webpack_public_path__ + "static/media/PGL_logo.f79cae13.png";